import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BrandThemeService } from './app/shared/services/brand-theme.service';

if (environment.production) {
  enableProdMode();
}

// Per-client brand theming (SAAS). Applied BEFORE bootstrap so the brand palette is in place before
// Angular's first paint (no flash). No-ops for the default brand. Phase 4 can replace the env source
// with a per-tenant value fetched from the backend.
new BrandThemeService().applyBrandColor((environment as { brandColor?: string }).brandColor);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
